const FILTER_KEY = 'userFilters';

export function getFilter(key = FILTER_KEY): Record<string, any> {
  const filterString = window.localStorage.getItem(key);
  if (filterString) {
    return JSON.parse(filterString);
  }
  return {};
}

export function setFilter(filter: Record<string, any>, key = FILTER_KEY): void {
  window.localStorage.setItem(key, JSON.stringify(filter));
}
